module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "registration-success g-py-170"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-12 offset-sm-0 col-xs-12 offset-sm-0"
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "success-div"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.messageHeader) + "!")]), _vm._v(" "), (_vm.isSuccess) ? _c('p', {
    staticClass: "success_msg"
  }, [_vm._v("\n                            You have successfully activated your account "), _c('br'), _c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    }
  }, [_vm._v("click here")]), _vm._v(" to go to the log in page.\n                        ")], 1) : _c('p', {
    staticClass: "success_msg"
  }, [_vm._v("\n                            Invalid activation code. Please try again.\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "success-div"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/loading.gif")
    }
  })]) : _vm._e()])])])]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9882220a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9882220a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/Activation.vue
// module id = 536
// module chunks = 3